import _ from 'lodash'
import { RootState } from '../../types/RootState'
import { createSelector } from '@reduxjs/toolkit'

class CompanyPaymentsSelectors {
  getCompanyPayments = (state: RootState) => state.companyPayments.companyPayments
  getHasCompanyPayments = (state: RootState) => !!state.companyPayments.companyPayments.length
  getPaginationTimestamp = createSelector(
    [
      (state: RootState) => {
        const datePaid =
          state.companyPayments.companyPayments[state.companyPayments.companyPayments.length - 1]
            ?.datePaid
        return datePaid
      },
    ],
    datePaid => {
      if (datePaid) {
        return new Date(datePaid)
      }
    },
  )
  getLoading = _.memoize(
    ({ loadingWhenInitial }: { loadingWhenInitial: boolean } = { loadingWhenInitial: true }) =>
      (state: RootState) =>
        loadingWhenInitial
          ? state.companyPayments.status === 'initial' || state.companyPayments.status === 'loading'
          : state.companyPayments.status === 'loading',
    props => !!props?.loadingWhenInitial,
  )
  getLoadingMore = (state: RootState) => state.companyPayments.status === 'loading-more'
  getInitial = (state: RootState) => state.companyPayments.status === 'initial'
  getHasError = (state: RootState) => state.companyPayments.status === 'failed'
  getError = (state: RootState) => state.companyPayments.error
}

export default new CompanyPaymentsSelectors()
